import { render, staticRenderFns } from "./Gas-station.vue?vue&type=template&id=645a9cfd&"
import script from "./Gas-station.vue?vue&type=script&lang=js&"
export * from "./Gas-station.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports